import styled from '@emotion/styled';
import {motion} from 'framer-motion';

import {ReactNode} from 'react';

const Container = styled(motion.div)`
    display: flex;
    flex-direction: column;
    padding: 0 16px;
    overflow-y: auto;
    flex: 1;
`

type Props = {
    children?: ReactNode;
};

export default function Content({children}: Props) {
    return (
        <Container>
            {children}
        </Container>
    );
}